(() => {
  if (window.textileSwatchToggleInitialized) return;
  window.textileSwatchToggleInitialized = true;

  let voGroupIndex = 0;
  let scanQueued = false;

  const ensureSwatchLightbox = () => {
    let dialog = document.querySelector('[data-il-swatch-lightbox]');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'il-swatch-lightbox';
    dialog.dataset.ilSwatchLightbox = '';
    dialog.setAttribute('aria-label', 'Større tekstilbilde');
    dialog.innerHTML = '<button type="button" class="il-swatch-lightbox__close" data-il-swatch-lightbox-close aria-label="Lukk">×</button><div class="il-swatch-lightbox__body"><img class="il-swatch-lightbox__image" data-il-swatch-lightbox-image src="" alt=""><p class="il-swatch-lightbox__title" data-il-swatch-lightbox-title></p></div>';
    document.body.append(dialog);

    dialog.querySelector('[data-il-swatch-lightbox-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    if (!document.getElementById('il-swatch-lightbox-styles')) {
      const style = document.createElement('style');
      style.id = 'il-swatch-lightbox-styles';
      style.textContent = '.swatch-input__label{position:relative}.il-swatch-image-zoom{position:absolute;right:4px;bottom:4px;z-index:4;display:flex;align-items:center;justify-content:center;width:22px;height:22px;border:1px solid rgba(255,255,255,.65);border-radius:50%;background:rgba(20,20,20,.78);color:#fff;font-size:14px;line-height:1;cursor:zoom-in;box-shadow:0 1px 4px rgba(0,0,0,.18)}.il-swatch-image-zoom:hover,.il-swatch-image-zoom:focus-visible{border-color:#111;outline:2px solid #fff;outline-offset:1px}.il-swatch-lightbox{width:min(88vw,660px);max-width:660px;height:fit-content;min-height:0;max-height:90vh;padding:0;border:0;border-radius:8px;background:#fff;color:#111;box-shadow:0 20px 60px rgba(0,0,0,.3);overflow:visible}.il-swatch-lightbox::backdrop{background:rgba(0,0,0,.68)}.il-swatch-lightbox__body{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:auto;min-height:0;padding:2.2rem;box-sizing:border-box}.il-swatch-lightbox__image{display:block;width:auto;max-width:100%;height:auto;max-height:72vh;object-fit:contain}.il-swatch-lightbox__title{margin:1.2rem 0 0;font-size:1.4rem;font-weight:600;text-align:center}.il-swatch-lightbox__close{position:absolute;top:-14px;right:-14px;z-index:2;display:flex;align-items:center;justify-content:center;width:36px;height:36px;padding:0;border:1px solid rgba(0,0,0,.2);border-radius:50%;background:#fff;color:#111;font-size:24px;line-height:1;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.18)}@media(max-width:749px){.il-swatch-image-zoom{width:24px;height:24px}.il-swatch-lightbox{width:min(92vw,660px)}.il-swatch-lightbox__body{padding:1.4rem}.il-swatch-lightbox__close{top:8px;right:8px}}';
      document.head.append(style);
    }

    return dialog;
  };

  const openSwatchLightbox = (trigger) => {
    const dialog = ensureSwatchLightbox();
    const image = dialog.querySelector('[data-il-swatch-lightbox-image]');
    const title = dialog.querySelector('[data-il-swatch-lightbox-title]');
    const src = trigger.dataset.ilSwatchZoomSrc || '';
    const label = trigger.dataset.ilSwatchZoomTitle || '';
    image.src = src;
    image.alt = label;
    title.textContent = label;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  const updateSelectedVoSwatch = (group) => {
    group.querySelectorAll('.bcpo-image-parent').forEach((item) => {
      item.classList.toggle('textile-swatch--selected', Boolean(item.querySelector('input:checked')));
    });
  };

  const enhanceVoOptions = (root, config) => {
    if (root.dataset.textileVoEnhanced === 'true') return;

    const wrappers = [...root.querySelectorAll('.selector-wrapper')];
    const textileWrapper = wrappers.find((wrapper) => {
      const title = wrapper.querySelector('.bcpo-title');
      return title && title.textContent.trim().toLowerCase().startsWith('tekstil');
    });
    const values = textileWrapper?.querySelector('.single-option-selector');
    const swatches = values ? [...values.querySelectorAll(':scope > .bcpo-image-parent')] : [];

    if (!textileWrapper || !values || swatches.length === 0) return;

    root.dataset.textileVoEnhanced = 'true';
    textileWrapper.classList.add('textile-variant-group-wrapper--vo');

    const group = document.createElement('section');
    group.className = 'textile-variant-group textile-variant-group--vo';
    group.dataset.textileGroup = '';
    group.dataset.textileExpanded = 'false';

    const heading = document.createElement('div');
    heading.className = 'textile-variant-group__heading';

    const title = document.createElement('h3');
    title.className = 'textile-variant-group__title';
    title.append(document.createTextNode('Standardtekstiler'));

    if (config.standardDelivery) {
      const delivery = document.createElement('span');
      delivery.textContent = ` · ${config.standardDelivery}`;
      title.append(delivery);
    }

    const description = document.createElement('p');
    description.className = 'textile-variant-group__description';
    description.textContent = 'Inkludert i fra-prisen';

    heading.append(title, description);
    values.classList.add('textile-variant-group__values');
    values.id = `VoTextileValues-${++voGroupIndex}`;

    swatches.forEach((swatch, index) => {
      if (index >= 6) swatch.classList.add('textile-swatch--collapsed');
    });

    textileWrapper.insertBefore(group, values);
    group.append(heading, values);

    if (swatches.length > 6) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'textile-variant-group__toggle btn--link';
      button.dataset.textileToggle = '';
      button.dataset.labelMore = 'Vis alle tekstiler';
      button.dataset.labelLess = 'Vis færre tekstiler';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', values.id);
      button.textContent = 'Vis alle tekstiler';
      group.append(button);
    }

    updateSelectedVoSwatch(group);
  };

  const scanVoOptions = () => {
    scanQueued = false;
    const config = Object.values(window.ilTextileToggleConfigs || {}).find(
      (item) => item.allTextilesStandard === true
    );
    if (!config) return;

    document.querySelectorAll('.best-custom-product-options').forEach((root) => {
      enhanceVoOptions(root, config);
    });
  };

  const queueVoScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(scanVoOptions);
  };

  document.addEventListener('click', (event) => {
    const zoom = event.target.closest('[data-il-swatch-zoom]');
    if (zoom) {
      event.preventDefault();
      event.stopPropagation();
      openSwatchLightbox(zoom);
      return;
    }

    const button = event.target.closest('[data-textile-toggle]');
    if (!button) return;

    const group = button.closest('[data-textile-group]');
    if (!group) return;

    const expanded = group.dataset.textileExpanded !== 'true';
    group.dataset.textileExpanded = String(expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
  });

  document.addEventListener('keydown', (event) => {
    const zoom = event.target.closest('[data-il-swatch-zoom]');
    if (zoom && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      event.stopPropagation();
      openSwatchLightbox(zoom);
    }
  });

  document.addEventListener('change', (event) => {
    const group = event.target.closest('.textile-variant-group--vo');
    if (group) updateSelectedVoSwatch(group);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanVoOptions, { once: true });
  } else {
    scanVoOptions();
  }

  new MutationObserver(queueVoScan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
